import { RoundFlag } from "./RoundFlag";

export function FRFlag() {
  return (
    <RoundFlag code="fr">
      <rect width="6.67" height="20" fill="#002654" />
      <rect x="6.67" width="6.66" height="20" fill="#FFFFFF" />
      <rect x="13.33" width="6.67" height="20" fill="#CE1126" />
    </RoundFlag>
  );
}
